import React from 'react';

import AnalyticsMetricCards from '../AnalyticsMetricCards';
import AnalyticsTrendChart from '../AnalyticsTrendChart';

const OverviewTab = ({ metrics, loading }) => {
  return (
    <>
      <AnalyticsMetricCards metrics={metrics} loading={loading} />
      <AnalyticsTrendChart data={metrics.trend} loading={loading} />
    </>
  );
};

export default OverviewTab;
